import { Typography } from "antd";
import PaymentStatus from "../../../types/paymentStatus.type";

interface StatusFormProps {
  status: string;
  content: string;
}

export const statusNames: Record<string, string> = {
  [PaymentStatus.REVIEW]: "Awaiting Review",
  [PaymentStatus.PENDING]: "Awaiting Review",
  [PaymentStatus.APPROVED]: "Approved",
  [PaymentStatus.PROCESSING]: "Processing",
  [PaymentStatus.REJECTED]: "Rejected",
  [PaymentStatus.COMPLETED]: "Completed",
  [PaymentStatus.SUCCESS]: "Success",
  [PaymentStatus.CANCELLED]: "Cancelled",
  [PaymentStatus.FAILED]: "Failed",
};

export const statusColors: Record<string, string> = {
  [PaymentStatus.REVIEW]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.PENDING]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.PROCESSING]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.APPROVED]: "rgb(24, 184, 83)",
  [PaymentStatus.REJECTED]: "rgb(236, 51, 51)",
  [PaymentStatus.COMPLETED]: "rgba(24, 184, 83, 1)",
  [PaymentStatus.SUCCESS]: "rgba(24, 184, 83, 1)",
  [PaymentStatus.FAILED]: "rgb(236, 51, 51)",
  [PaymentStatus.CANCELLED]: "rgba(29, 171, 241, 1)",
};

const StatusFormTransaction = ({ status, content }: StatusFormProps) => {
  return (
    <div className="form-transaction-status-box">
      <div className="form-transaction-status-box-title">
        <div
          style={{
            borderRadius: "6px",
            width: "fit-content",
            padding: "3px 8px",
            background: statusColors[status],
          }}
        >
          {statusNames[status]}
        </div>
        {status === PaymentStatus.REJECTED ||
        status === PaymentStatus.FAILED ? (
          <Typography className={`form-transaction-status-box-content`}>
            {`Reason: ${content}`}
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

export default StatusFormTransaction;
